import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './CondensedMergeStatus.module.css'

export function CondensedMergeStatusSkeleton() {
  return (
    <ul className={styles.statusList} aria-busy="true">
      {[0, 1, 2].map(i => (
        <li key={i} className={styles.statusRow}>
          <SkeletonBox height="16px" width="16px" />
          <SkeletonText size="bodySmall" className={styles.skeletonLabel} />
        </li>
      ))}
    </ul>
  )
}
